import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getGalleryBySlug, galleries } from '../data/galleries';
import { PageBanner } from '../components/PageBanner';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { ImageGallery } from '../components/ImageGallery';
import { RelatedPages } from '../components/RelatedPages';
export function AlbumDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const album = slug ? getGalleryBySlug(slug) : undefined;
  if (!album) return <Navigate to="/gallery" replace data-id="element-578" />;
  const otherAlbums = galleries.filter(g => g.id !== album.id).slice(0, 3).map(g => ({
    title: g.name,
    image: g.image,
    link: `/gallery/${g.id}`
  }));
  return <div className="w-full bg-club-canvas pb-24" data-id="element-579">
      <PageBanner title={album.name} eyebrow="Gallery Album" image={album.image} data-id="element-580" />

      <div className="max-w-7xl mx-auto px-4 mt-8" data-id="element-581">
        <Breadcrumbs items={[{
        label: 'Gallery',
        path: '/gallery'
      }, {
        label: album.name
      }]} data-id="element-582" />

        <div className="mt-8 mb-16 text-center max-w-3xl mx-auto" data-id="element-583">
          <p className="text-xl text-club-ink/80 font-light leading-relaxed" data-id="element-584">
            {album.desc}
          </p>
        </div>

        <ImageGallery images={album.images} data-id="element-585" />

        <RelatedPages title="More Albums" pages={otherAlbums} data-id="element-586" />
      </div>
    </div>;
}